import { render, staticRenderFns } from "./down-list.vue?vue&type=template&id=4a9b2798&scoped=true"
import script from "./down-list.vue?vue&type=script&lang=js"
export * from "./down-list.vue?vue&type=script&lang=js"
import style0 from "./down-list.vue?vue&type=style&index=0&id=4a9b2798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9b2798",
  null
  
)

export default component.exports